const optionsNotiflix = {
  clickToClose: true,
  cssAnimationStyle: 'from-top',
  position: 'center-center',
  fontSize: '17px',
};

export { optionsNotiflix };
